module.exports = __webpack_public_path__ + "img/wallpaper-4.3eaebc09.png";